import React, { useEffect, useState } from "react";
import "./Forecast.css";
import axios from "axios";
import WeatherIcon from "./WeatherIcon";

const Forecast = ({ coordinates, unit }) => {
  const [activeTab, setActiveTab] = useState("weekly");
  const [hourlyData, setHourlyData] = useState(null);
  const [weeklyData, setWeeklyData] = useState(null);
  const [loading, setLoading] = useState(true);

  const colors = [
    "#CEA0AA",
    "#B8d8E3",
    "#FEE1DD",
    "#FBE1CE",
    "#9dcec3",
    "#BBDABB",
    "#DAF2F5",
  ];

  useEffect(() => {
    if (coordinates) {
      const apiKey = "fgHkhnkDouCeBnbpb74jMw9OgFrVcG35"; // replace with your actual key
      const apiUrl = `https://api.pirateweather.net/forecast/${apiKey}/${coordinates.lat},${coordinates.lon}?units=${unit === "celsius" ? "si" : "us"}`;

      axios
        .get(apiUrl)
        .then((response) => {
          setHourlyData(response.data.hourly.data.slice(0, 12));
          setWeeklyData(response.data.daily.data.slice(0, 7));
          setLoading(false);
        })
        .catch((err) => {
          console.error("Weather API error:", err);
          setLoading(false);
        });
    }
  }, [coordinates, unit]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  if (loading) {
    return <div className="Loading">Loading...</div>;
  }

  return (
    <div className="Forecast">
      <div className="tab-bar">
        <div
          className={`tab ${activeTab === "weekly" ? "active" : ""}`}
          onClick={() => handleTabClick("weekly")}
        >
          Weekly Forecast
        </div>
        <div
          className={`tab ${activeTab === "hourly" ? "active" : ""}`}
          onClick={() => handleTabClick("hourly")}
        >
          Hourly Forecast
        </div>
      </div>
      {activeTab === "weekly" ? (
        <div className="weekly-forecast">
          {weeklyData.map((day, index) => (
            <div
              key={index}
              className="card"
              style={{ backgroundColor: colors[index % colors.length] }}
            >
              <div className="card-body">
                <WeatherIcon code={day.icon} animate={true} size={64} />
                <div className="temp-forecast">
                  <span className="weekday">
                    {new Date(day.time * 1000).toLocaleDateString("en-US", {
                      weekday: "short",
                    })}
                  </span>
                  <span className="temperature">
                    min {Math.round(day.temperatureMin)}° | max{" "}
                    {Math.round(day.temperatureMax)}°
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="hourly-forecast">
          {hourlyData.map((hour, index) => (
            <div
              key={index}
              className="card"
              style={{ backgroundColor: colors[index % colors.length] }}
            >
              <div className="card-body">
                <WeatherIcon code={hour.icon} animate={true} size={64} />
                <div className="temp-forecast">
                  <span className="weekday">
                    {new Date(hour.time * 1000).getHours()}:00
                  </span>
                  <span className="temperature">
                    {Math.round(hour.temperature)}°
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Forecast;
